import { Link, useLocation } from "react-router-dom";
import { BookOpen, CalendarClock, History, LineChart, Server, Users, Zap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TRADER_TABS = [
  { to: "/trade", label: "Trade", icon: Zap, testid: "tab-trade" },
  { to: "/positions", label: "Positions", icon: LineChart, testid: "tab-positions" },
  { to: "/history", label: "History", icon: History, testid: "tab-history" },
];

const ADMIN_TABS = [
  { to: "/admin", label: "Traders", icon: Users, testid: "tab-traders" },
  { to: "/admin/pods", label: "Infra", icon: Server, testid: "tab-infra" },
  { to: "/admin/leads", label: "Leads", icon: CalendarClock, testid: "tab-leads" },
  { to: "/admin/logic", label: "Logic", icon: BookOpen, testid: "tab-logic" },
];

export const MobileTabs = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const tabs = user?.role === "admin" ? ADMIN_TABS : TRADER_TABS;

  return (
    <nav
      data-testid="mobile-tabs"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-zinc-800 bg-black/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid" style={{ gridTemplateColumns: `repeat(${tabs.length}, 1fr)` }}>
        {tabs.map(({ to, label, icon: Icon, testid }) => {
          const active = pathname === to;
          return (
            <Link
              key={to}
              to={to}
              data-testid={testid}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] text-[10px] uppercase tracking-[0.12em] font-semibold transition-colors duration-200 ${
                active ? "text-emerald-300" : "text-zinc-300 active:text-white"
              }`}
            >
              <Icon className="h-[18px] w-[18px]" />
              {label}
              <span
                className={`h-0.5 w-6 rounded-full transition-colors duration-200 ${
                  active ? "bg-emerald-400" : "bg-transparent"
                }`}
              />
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
